import { withStylePrefix } from '../common/withStylePrefix';
import { SidePanelComponent, sidePanelTemplate } from './SidePanel';
import styles from './SidePanel.styles.scss';
export const sidePanelDefinition = {
    baseName: 'side-panel',
    template: sidePanelTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonSidePanel = SidePanelComponent.compose(sidePanelDefinition);
